import React from 'react'

export const StatusPanelWrapper: React.FC = ({ children }) => (
  <div className="ag-status-name-value ag-status-panel">{children}</div>
)
